import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import { toast } from "react-toastify";
import { Backr, Table } from "./styles";
import api from "../../../../services/api";

function TableComponent() {
  const [tokens, setTokens] = useState([]);

  async function loadTokens() {
    const response = await api.get("/list_opened_contracts");
    setTokens(response.data);
  }

  useEffect(() => {
    loadTokens();
  }, []);

  async function acceptDataBaseCreation(token, cgc, company, companyId) {
    api
      .post("/activate_base", {
        cgc,
        company,
        token,
        companyId,
      })
      .then((response) => {
        toast.success(response.data.message);
        loadTokens();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  }

  if (!Array.isArray(tokens) || tokens.length === 0) {
    return <p>Não há tokens em aberto para liberação de base</p>;
  }

  return (
    <Table>
      <thead>
        <tr>
          <th>Clinica</th>
          <th>CPF/CPNJ</th>
          <th>Usuario</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {tokens.map((tokenData) => (
          <tr key={tokenData.token} style={{ marginTop: "5px", marginBottom: "50px" }}>
            <td style={{ marginTop: "5px" }}>
              <div>
                <span>{tokenData.nome_empresa} </span>
                <span>{tokenData.is_test}</span>
              </div>
            </td>
            <td>
              <div>
                <span>{tokenData.cgc}</span>
              </div>
            </td>
            <td>
              <div>
                <span>Usuario: {tokenData.id}</span>
              </div>
            </td>
            <td>
              <Row className="justify-content-around" style={{ margin: 0 }}>
                <Col style={{ padding: 0, cursor: "pointer" }}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <FaCheck
                      onClick={() => {
                        acceptDataBaseCreation(
                          tokenData.token,
                          tokenData.cgc,
                          tokenData.nome_empresa,
                          tokenData.cod_empresa
                        );
                      }}
                      color="green"
                    />
                  </div>
                </Col>
              </Row>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default function BaseCreationToken({ role }) {
  if (role !== "MASTER") {
    return null;
  }

  return (
    <Backr>
      <h1>Tokens liberação de base</h1>
      <TableComponent />
    </Backr>
  );
}

BaseCreationToken.propTypes = {
  role: PropTypes.string.isRequired,
};
